import type { Issue } from "contracts/api/issue/responses";
import { For } from "solid-js";
import { SeverityBadge, StatusBadge } from "../../ui/Badge";
import { EmptyState } from "../../ui/EmptyState";
import { uniqueCurrentPagesForIssue } from "../scan/issuePageResolution";
import { clientIssueTitle } from "../scan/issueText";
import { rankBySeverity } from "../website/issueModel";
import type { WebsiteContext } from "../website/store";

export function AttachedIssues(props: {
  issues: Issue[];
  context: WebsiteContext;
}) {
  return (
    <section class="ov-section">
      <div class="section-head">
        <div>
          <h2 class="section-title">Attached issues</h2>
          <span class="section-sub">
            {props.issues.length} issue{props.issues.length === 1 ? "" : "s"}{" "}
            tied to this metric
          </span>
        </div>
      </div>
      {props.issues.length === 0 ? (
        <EmptyState title="No issues for this metric" />
      ) : (
        <div class="mini-issues card">
          <For each={rankBySeverity(props.issues)}>
            {(issue) => {
              const pageCount = () => {
                const data = props.context.data();
                return data
                  ? uniqueCurrentPagesForIssue(data, issue).length
                  : 0;
              };
              return (
                <a
                  class="mini-issue"
                  href={`/w/${props.context.websiteId}/scan/issues/${issue.id}?from=issues`}
                >
                  <SeverityBadge severity={issue.severity} />
                  <span class="mini-issue-title">
                    {clientIssueTitle(issue)}
                  </span>
                  <StatusBadge status={issue.status} />
                  <span class="mini-issue-impact mono">
                    {pageCount()} page{pageCount() === 1 ? "" : "s"}
                  </span>
                </a>
              );
            }}
          </For>
        </div>
      )}
    </section>
  );
}
